// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/vercel/path0/web/src/pages/add-knowledge/components/knowledge-file/model';

export const models = {
model_1: { namespace: 'add-knowledge.components.knowledge-file.model', model: model_1 },
} as const
